
export default function Staff() {
  const staff = [
    {
      name: '岡山 太郎',
      position: '代表取締役',
      experience: '25年',
      speciality: '住宅リフォーム全般',
      image: 'https://public.readdy.ai/ai/img_res/58482a8aa44a9268aa654f449b73ead5.jpg',
      message: '岡山県でのリフォーム工事25年の経験を活かし、お客様に最高の住環境をご提供いたします。'
    },
    {
      name: '倉敷 花子',
      position: '設計・デザイン担当',
      experience: '15年',
      speciality: 'インテリアデザイン',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Japanese%20woman%20architect%20in%20her%2040s%2C%20friendly%20smile%2C%20wearing%20professional%20attire%2C%20interior%20designer%2C%20creative%20professional%2C%20confident%20appearance%2C%20clean%20background%2C%20portrait%20style&width=300&height=400&seq=staff2&orientation=portrait',
      message: 'お客様のライフスタイルに合わせた機能的で美しい空間づくりを心がけています。'
    },
    {
      name: '岡山 次郎',
      position: '施工管理責任者',
      experience: '20年',
      speciality: '現場管理・品質管理',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Japanese%20construction%20manager%20in%20his%2040s%2C%20reliable%20appearance%2C%20wearing%20work%20uniform%2C%20experienced%20craftsman%2C%20safety-conscious%2C%20skilled%20worker%2C%20clean%20background%2C%20portrait%20style&width=300&height=400&seq=staff3&orientation=portrait',
      message: '安全で確実な施工を第一に、品質の高い工事をお約束いたします。'
    }
  ];

  return (
    <section className="py-12 sm:py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-12">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3 sm:mb-4">
            <strong>スタッフ紹介</strong>
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-gray-600 max-w-2xl mx-auto px-4">
            経験豊富なプロフェッショナルが、岡山市・倉敷市でのリフォーム工事を責任を持って担当いたします
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8">
          {staff.map((member, index) => (
            <div key={index} className="bg-gray-50 rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
              <div className="h-64 sm:h-80 overflow-hidden">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-5 sm:p-6">
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2">{member.name}</h3>
                <p className="text-teal-600 font-semibold mb-2 sm:mb-3 text-sm sm:text-base">{member.position}</p>
                <div className="space-y-1 text-xs sm:text-sm text-gray-600 mb-3 sm:mb-4">
                  <p><strong>経験年数:</strong> {member.experience}</p>
                  <p><strong>専門分野:</strong> {member.speciality}</p>
                </div>
                <p className="text-gray-700 text-xs sm:text-sm leading-relaxed">{member.message}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
